// Appcopy.js
import React, { lazy, Suspense, useEffect, useLayoutEffect, useMemo, useState } from "react";
import usePagination from "./usePagination.js";
import reviewssw from "./csvjson.json";
import reviewsst from "./csvjsontr.json";
import CardGroup from "./CardGroup";
import "./App.css";
import { BrowserRouter as Router, Route, useLocation } from "react-router-dom";
import NaviBar from "./NaviBar";
import styled from "styled-components";
import Search from "./Search";
import { Helmet } from "react-helmet";
import axios from "axios";
import { loadSaleStatus } from "./Cards";

const Flip = lazy(() => import("./Flip"));
const Content = lazy(() => import("./Content"));
const GiftCards = lazy(() => import("./GiftCards"));
const FAQ = lazy(() => import("./FAQ"));
const MainPage = lazy(() => import("./MainPage"));
const Pasabuy = lazy(() => import("./Pasabuy"));

const readLow = (params) => {
  const value = params.get("low");
  return ["new_low", "matches_low", "not_low"].includes(value) ? value : "";
};

const RouteLoadingFallback = () => (
  <div className="route-loading" role="status">
    Loading…
  </div>
);

var today = new Date();
var dd = String(today.getDate()).padStart(2, "0");
var mm = String(today.getMonth() + 1).padStart(2, "0");
var yyyy = today.getFullYear();

today = yyyy + "-" + mm + "-" + dd;

// ---------------- Minimal list route wrapper ----------------
function ListPage({ defaults, SearchCmpProps, CardGroupProps, HelmetProps }) {
  const location = useLocation();

  const parseRegionList = (value) =>
    String(value || "")
      .split(",")
      .map((x) => x.trim().toUpperCase())
      .filter(Boolean);

  const {
    setPlatformField,
    setPlatformDropDown,
    setRegionFilter,
    setSearchQuery,
    onDropDownChange,
    onFilterChange,
    clearGenre,
    onLatestChange,
    onLatestDrop,
    onPriceRangeDrop,
    onPriceRangeChange,
    onRegionChange,
    setLowFilter,
    jumpPage,
  } = CardGroupProps;

useLayoutEffect(() => {
  if (defaults?.platform !== undefined) {
    setPlatformField(defaults.platform);
    setPlatformDropDown(defaults.platformLabel ?? (defaults.platform || "All Platforms"));
  }
}, [defaults?.platform, defaults?.platformLabel, location.pathname]);

useEffect(() => {
    const params = new URLSearchParams(location.search);

    const readQP = (key, def = "") => {
      const raw = params.get(key);
      if (raw == null) return def;
      return decodeURIComponent(raw.replace(/\+/g, " "));
    };

    const s = readQP("s", "");
    const genre = readQP("genre", "All Genres");
    const sort = readQP("sort", "Popular");
    const price = readQP("price", "All Price Range");
    const regionIn = parseRegionList(params.get("regionIn"));
    const regionEx = parseRegionList(params.get("regionEx"));
    const regionLegacy = (params.get("region") || "").trim().toUpperCase();
    const region = {
      include: regionIn.length ? regionIn : regionLegacy ? [regionLegacy] : [],
      exclude: regionEx,
    };
    const page = parseInt(params.get("page") || "1", 10);

    setSearchQuery(s);

    onDropDownChange(genre);
    if (genre === "All Genres") {
      clearGenre();
    } else {
      onFilterChange(genre);
    }

    onLatestChange(sort);
    onLatestDrop(sort);

    onPriceRangeDrop(price);
    onPriceRangeChange(price);

    onRegionChange(region);
    setRegionFilter(region);
    setLowFilter(readLow(params));

    jumpPage(Number.isFinite(page) ? page : 1);
  }, [location.search]);

  return (
    <>
      <Search {...SearchCmpProps} />
      <CardGroup {...CardGroupProps} />
      {HelmetProps && (
        <Helmet>
          <meta charSet="utf-8" />
          <title>{HelmetProps.title}</title>
          <meta name="description" content={HelmetProps.description} />
          <link rel="canonical" href={HelmetProps.canonical} />
          <meta name="robots" content="index,follow" />
        </Helmet>
      )}
    </>
  );
}

export default function Main() {
useEffect(() => {
  if ("scrollRestoration" in window.history) {
    window.history.scrollRestoration = "auto";
  }
}, []);

  function sortJson(element, prop, propType, asc) {
    switch (propType) {
      case "int":
        element = element.sort(function (a, b) {
          const aValue = parseInt(a[prop]) || Number.MIN_SAFE_INTEGER;
          const bValue = parseInt(b[prop]) || Number.MIN_SAFE_INTEGER;
          return asc ? aValue - bValue : bValue - aValue;
        });
        break;
      case "date":
        element = element.sort(function (a, b) {
          const aDate = new Date(a[prop]);
          const bDate = new Date(b[prop]);
          return asc ? aDate - bDate : bDate - aDate;
        });
        break;
      default:
        element = element.sort(function (a, b) {
          const aValue = (a[prop] || "").toString().toLowerCase();
          const bValue = (b[prop] || "").toString().toLowerCase();
          return asc ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
        });
    }
    return element;
  }

  const reviewsswf = reviewssw.filter((review) => review.SaleStarted !== "0000-00-00");
  const reviewsstf = reviewsst
    .map((review) => ({
      ...review,

      platform: "Playstation",

      IsPS4: Number(review.IsPS4),
      IsPS5: Number(review.IsPS5),

      platforms: [
        Number(review.IsPS4) === 1 ? "PS4" : null,
        Number(review.IsPS5) === 1 ? "PS5" : null,
      ].filter(Boolean),

      Image: review.Image || review.img,
      URL: review.URL || review.url,
      genre: review.genre || review.Genre,
      description: review.description || "",

      Price: review.trPrice || review.usPrice || "",
      SalePrice: review.trSalePrice || review.usSalePrice || "",
    }))
    .filter(
      (review) =>
        review.ReleaseDate !== undefined &&
        review.SaleEnds !== undefined &&
        review.SaleStarted !== undefined &&
        review.Publisher !== undefined &&
        review.genre !== undefined
    );

  // ---------------- helper to decode '+' → space ----------------

function getDeepSaleRegionalPrices(review) {
  const prices = {};

  if (!datam || !datam.PHP) return [];

  if (review.platform === "Playstation") {
    Object.entries(getPsRegionalPrices(review)).forEach(([code, php]) => {
      if (Number.isFinite(php) && php > 0) {
        prices[code] = php;
      }
    });
  } else {
    addPhpCandidate(prices, "US", review.SalePrice || review.Price, "USD", datam);
    addPhpCandidate(prices, "CA", review.CanadaPrice, "CAD", datam);
    addPhpCandidate(prices, "PE", review.PeruPrice, "PEN", datam);
    addPhpCandidate(prices, "AU", review.AustraliaPrice, "AUD", datam);
    addPhpCandidate(prices, "CO", review.ColombiaPrice, "COP", datam);
    addPhpCandidate(prices, "ZA", review.SouthafricaPrice, "ZAR", datam);
    addPhpCandidate(prices, "BR", review.BrazilPrice, "BRL", datam);
    addPhpCandidate(prices, "NO", review.NorwayPrice, "NOK", datam);
    addPhpCandidate(prices, "PL", review.PolandPrice, "PLN", datam);
    addPhpCandidate(prices, "NZ", review.NewZealandPrice, "NZD", datam);
    addPhpCandidate(prices, "MX", review.MexicoPrice, "MXN", datam);
    addPhpCandidate(prices, "HK", review.HongKongPrice, "HKD", datam);
    addPhpCandidate(prices, "KR", review.KoreaPrice, "KRW", datam);
    addPhpCandidate(prices, "JP", review.JapanPrice, "JPY", datam);
    addPhpCandidate(prices, "SG", review.SingaporePrice, "SGD", datam);
    addPhpCandidate(prices, "MY", review.MalaysiaPrice, "MYR", datam);
    addPhpCandidate(prices, "TH", review.ThailandPrice, "THB", datam);

    const ars = +review.ArgentinaPrice;
    if (Number.isFinite(ars) && ars > 0 && datam.ARS) {
      const phpPerARS = Number(datam.PHP) / Number(datam.ARS);
      const basePhp = ars * phpPerARS;
      const vat = basePhp * 0.21;
      const regionality =
        basePhp * 1.21 * ((1500 - 12100 * phpPerARS) / (12100 * phpPerARS));

      prices.AR = basePhp + vat + regionality;
    }
  }

  return Object.entries(prices)
    .map(([region, php]) => ({ region, php }))
    .filter((x) => Number.isFinite(x.php) && x.php > 0)
    .sort((a, b) => a.php - b.php);
}

const DEEP_SALE_THRESHOLD = 0.65;

function isDeepSale(review) {
  const prices = getDeepSaleRegionalPrices(review);

  if (prices.length < 2) return false;

  const cheapest = prices[0].php;

  // Only 2 prices available
  if (prices.length === 2) {
    const second = prices[1].php;
    return cheapest <= second * DEEP_SALE_THRESHOLD;
  }

  // 3+ prices available
  const third = prices[2].php;
  return cheapest <= third * DEEP_SALE_THRESHOLD;
}

  const readQP = (params, key, def = "") => {
    const raw = params.get(key);
    if (raw == null) return def;
    return decodeURIComponent(raw.replace(/\+/g, " "));
  };

  const parseRegionList = (value) =>
    String(value || "")
      .split(",")
      .map((x) => x.trim().toUpperCase())
      .filter(Boolean);

  const { search } = window.location;
  const _params0 = new URLSearchParams(search);
  const query = (() => {
    const raw = _params0.get("s");
    return raw ? decodeURIComponent(raw.replace(/\+/g, " ")) : "";
  })();

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    const listPaths = ["/allgames", "/switch", "/switch-2", "/playstation"];

    if (location.state?.scrollToTop) {
      window.scrollTo({ left: 0, top: 0, behavior: "instant" });
      return;
    }

    // Let list pages keep/restored scroll when returning from content
    if (listPaths.includes(location.pathname)) return;

    window.scrollTo({ left: 0, top: 0, behavior: "instant" });
  }, [location.pathname, location.state]);

  return null;
}

  const theURLa = "https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/usd.json";

  const [darkMode, setDarkMode] = useState(() => localStorage.getItem("theme") === "dark");

useEffect(() => {
  document.documentElement.classList.toggle("dark-mode", darkMode);
  localStorage.setItem("theme", darkMode ? "dark" : "light");
}, [darkMode]);
  const [datam, setDatam] = React.useState({});
  const [makeswitch, setMakeswitch] = React.useState(null);

useEffect(() => {
  axios
    .get(theURLa)
    .then((response) => {
      const rates = response.data.usd; // always USD base

      // Convert keys to UPPERCASE
      const uppercased = Object.fromEntries(
        Object.entries(rates).map(([k, v]) => [k.toUpperCase(), v])
      );

      setDatam(uppercased);
      setMakeswitch("1");
    })
    .catch((error) => {
      console.error("Error fetching currency data:", error);
    });
}, []);

  const [priceRangeField, setPriceRangeField] = useState(99999);
  const [priceRangeLow, setPriceRangeLow] = useState(0);
  const [priceRangeLowExclusive, setPriceRangeLowExclusive] = useState(false);
  const [priceRangeDropDown, setPriceRangeDropDown] = useState("All Price Range");
  const [platformField, setPlatformField] = useState("");
  const [filterField, setFilterField] = useState("");
  const normalizeRegionFilter = React.useCallback((input) => {
    if (typeof input === "string") {
      const code = input.trim().toUpperCase();
      return { include: code ? [code] : [], exclude: [] };
    }

    const includeRaw = Array.isArray(input?.include) ? input.include : [];
    const excludeRaw = Array.isArray(input?.exclude) ? input.exclude : [];

    const include = [...new Set(includeRaw.map((x) => String(x || "").trim().toUpperCase()).filter(Boolean))];
    const exclude = [...new Set(excludeRaw.map((x) => String(x || "").trim().toUpperCase()).filter(Boolean))]
      .filter((code) => !include.includes(code));

    return { include, exclude };
  }, []);

  const [regionFilter, _setRegionFilter] = useState({ include: [], exclude: [] });
  const setRegionFilter = React.useCallback(
    (next) => {
      _setRegionFilter(normalizeRegionFilter(next));
    },
    [normalizeRegionFilter]
  );
  const [genreDropDown, setGenreDropDown] = useState("All Genres");
  const [platformDropDown, setPlatformDropDown] = useState("All Platforms");
  const [latestField, setLatestField] = useState([]);
  const [latestDropDown, setLatestDropDown] = useState("Popular");

  const [originalData, setOriginalData] = useState([]);

  const [lowFilter, setLowFilter] = useState("");
  const [saleStatus, setSaleStatus] = useState(null);
  useEffect(() => {
    loadSaleStatus().then(setSaleStatus);
  }, []);

  useEffect(() => {
    const sortedSwitch = sortJson(reviewsswf, "Popularity", "int", false);
    const sortedPlaystation = sortJson(reviewsstf, "Popularity", "int", false);
    const reviews = sortedPlaystation.concat(sortedSwitch);
    setOriginalData(reviews);
    setLatestField(reviews);
  }, []);

  // Re-apply current sort when data or FX rates are ready.
useEffect(() => {
  if (!originalData.length) return;

  const needsPriceSort =
    latestDropDown === "Price ↓" || latestDropDown === "Price ↑";

  const dataToSort = needsPriceSort
    ? originalData.map((r) => ({
        ...r,
        _lowestPHP: lowestPhpFor(r),
      }))
    : originalData;

  const sortFn = SORTERS[latestDropDown] || SORTERS["Popular"];
  setLatestField([...dataToSort].sort(sortFn));
}, [originalData, latestDropDown, datam]);
  const onPriceRangeDrop = (dropDownValue) => setPriceRangeDropDown(dropDownValue);
  const onPlatformDrop = (dropDownValue) => setPlatformDropDown(dropDownValue);
  const onLatestDrop = (dropDownValue) => setLatestDropDown(dropDownValue);
  const onDropDownChange = (dropDownValue) => setGenreDropDown(dropDownValue);

  const clearPriceRange = () => {
    setPriceRangeLow(0);
    setPriceRangeLowExclusive(false);
    setPriceRangeField(99999);
  };

  const clearFilter = () => {
    clearPriceRange();
    clearSearchChange();
    onDropDownChange("All Genres");
    onPriceRangeDrop("All Price Range");
    onPlatformChange("");
    onPlatformDrop("All Platforms");
    onFilterChange("");
    onLatestChange("Popular");
    onLatestDrop("Popular");
    setRegionFilter({ include: [], exclude: [] });
    setLowFilter("");
  };

  const clearGenre = () => setFilterField("");

  // Price map + setter
  const PRICE_MAP = {
    "All Price Range": [0, Number.POSITIVE_INFINITY, false],
    "P0-100": [0, 100, false],
    "P101-250": [100, 250, true],
    "P251-500": [250, 500, true],
    "P501-750": [500, 750, true],
    "P751-1,000": [750, 1000, true],
    "P1,001-1,500": [1000, 1500, true],
    "P1,501-2,000": [1500, 2000, true],
    "P2,001-2,500": [2000, 2500, true],
    "P2,501+": [2500, Number.POSITIVE_INFINITY, true],
    "≤ P100": [0, 100, false],
    "≤ P250": [0, 250, false],
    "≤ P500": [0, 500, false],
    "≤ P750": [0, 750, false],
    "≤ P1,000": [0, 1000, false],
    "≤ P1,500": [0, 1500, false],
    "≤ P2,000": [0, 2000, false],
    "≤ P2,500": [0, 2500, false],
    "≤ P2,500+": [0, Number.POSITIVE_INFINITY, false],
  };

  const onPriceRangeChange = (label) => {
    const compactRange = label.replace(/,/g, "").match(/^P(\d+)-(\d+)$/);
    const compactUpper = label.replace(/,/g, "").match(/^P(\d+)\+$/);
    const parsedRange = compactRange
      ? [compactRange[1] === "0" ? 0 : Number(compactRange[1]) - 1, Number(compactRange[2]), compactRange[1] !== "0"]
      : compactUpper
      ? [Number(compactUpper[1]) - 1, Number.POSITIVE_INFINITY, true]
      : PRICE_MAP[label] ?? PRICE_MAP["All Price Range"];
    const [min, max, exclusive] = parsedRange;
    setPriceRangeLow(min);
    setPriceRangeLowExclusive(exclusive);
    setPriceRangeField(max);
  };

  const onPriceRangeBoundsChange = (min, max) => {
    const lowerLabel = min === 0 ? "P0" : `P${min + 1}`;
    const label = Number.isFinite(max)
      ? `${lowerLabel}-${max.toLocaleString()}`
      : `${lowerLabel}+`;
    setPriceRangeLow(min);
    setPriceRangeLowExclusive(min > 0);
    setPriceRangeField(max);
    setPriceRangeDropDown(min === 0 && !Number.isFinite(max) ? "All Price Range" : label);
  };

  // Sorting
const SORTERS = {
  Popular: (a, b) => b.Popularity - a.Popularity,
  "Top Rated": (a, b) => b.SCORE - a.SCORE,
  "New Discounts": (a, b) =>
    new Date(b.SaleStarted) - new Date(a.SaleStarted) || b.SCORE - a.SCORE,
  "Latest Release": (a, b) => new Date(b.ReleaseDate) - new Date(a.ReleaseDate),
  "Price ↓": (a, b) => a._lowestPHP - b._lowestPHP,
  "Price ↑": (a, b) => b._lowestPHP - a._lowestPHP,
"Best Deals": (a, b) =>
(b.Popularity || 0) - (a.Popularity || 0) ||
  (b.SCORE || 0) - (a.SCORE || 0) ||
  new Date(b.ReleaseDate) - new Date(a.ReleaseDate),
};

  const onLatestChange = (label) => {
    const needsPriceSort = label === "Price ↓" || label === "Price ↑";

    const dataToSort = needsPriceSort
      ? originalData.map((r) => ({
          ...r,
          _lowestPHP: lowestPhpFor(r),
        }))
      : originalData;

    const sortFn = SORTERS[label] || SORTERS["Popular"];
    setLatestField([...dataToSort].sort(sortFn));
    setLatestDropDown(label);
  };

  const onPlatformChange = (filterPlatform) => setPlatformField(filterPlatform);
  const onRegionChange = (region) => setRegionFilter(region);
  const onFilterChange = (filterGenre) => setFilterField(filterGenre);

  const [searchQuery, setSearchQuery] = useState(query || "");
  const [hydrated, setHydrated] = useState(false); // hydration flag
  const prevFilterSigRef = React.useRef(null);     // snapshot of filters post-hydration

  const clearSearchChange = () => setSearchQuery("");




  function addPhpCandidate(bucket, key, amt, ccy, rates) {
    const n = +amt;
    if (!Number.isFinite(n) || n <= 0) return;
    const base = Number(rates[ccy]);
    const php = Number(rates.PHP);
    if (!base || !php) return;
    bucket[key] = n * (php / base);
  }

  function parseTurkeyPrice(value) {
    if (value === undefined || value === null || value === "" || value === "null") return "";
    return Number(String(value).replace(".", "")) / 100;
  }

  function getPsRegionalPrices(review) {
    const prices = {};

    addPhpCandidate(prices, "ID", review.idSalePrice || review.idPrice, "IDR", datam);
    addPhpCandidate(prices, "IN", review.inSalePrice || review.inPrice, "INR", datam);
    addPhpCandidate(prices, "SG", review.sgSalePrice || review.sgPrice, "SGD", datam);

    const trPrice = parseTurkeyPrice(review.trSalePrice || review.trPrice);
    addPhpCandidate(prices, "TR", trPrice, "TRY", datam);

    addPhpCandidate(prices, "US", review.usSalePrice || review.usPrice, "USD", datam);
    addPhpCandidate(prices, "HK", review.hkSalePrice || review.hkPrice, "HKD", datam);
    return prices;
  }

  function lowestPhpFor(review) {
    if (!datam || !datam.PHP) return Infinity;
    const prices = {};

    if (review.platform === "Playstation") {
      Object.assign(prices, getPsRegionalPrices(review));
    } else {
      addPhpCandidate(prices, "US_Sale", review.SalePrice, "USD", datam);
      addPhpCandidate(prices, "US_Full", review.Price, "USD", datam);
    }

    addPhpCandidate(prices, "Canada", review.CanadaPrice, "CAD", datam);
    addPhpCandidate(prices, "Peru", review.PeruPrice, "PEN", datam);
    addPhpCandidate(prices, "Australia", review.AustraliaPrice, "AUD", datam);
    addPhpCandidate(prices, "Colombia", review.ColombiaPrice, "COP", datam);
    addPhpCandidate(prices, "South Africa", review.SouthafricaPrice, "ZAR", datam);
    addPhpCandidate(prices, "Brazil", review.BrazilPrice, "BRL", datam);
    addPhpCandidate(prices, "Norway", review.NorwayPrice, "NOK", datam);
    addPhpCandidate(prices, "Poland", review.PolandPrice, "PLN", datam);
    addPhpCandidate(prices, "New Zealand", review.NewZealandPrice, "NZD", datam);
    addPhpCandidate(prices, "Mexico", review.MexicoPrice, "MXN", datam);
    addPhpCandidate(prices, "Hong Kong", review.HongKongPrice, "HKD", datam);
    addPhpCandidate(prices, "Korea", review.KoreaPrice, "KRW", datam);
    addPhpCandidate(prices, "Japan", review.JapanPrice, "JPY", datam);
    addPhpCandidate(prices, "Singapore", review.SingaporePrice, "SGD", datam);
    addPhpCandidate(prices, "Malaysia", review.MalaysiaPrice, "MYR", datam);
    addPhpCandidate(prices, "Thailand", review.ThailandPrice, "THB", datam);
    addPhpCandidate(prices, "Turkey", review.TurkeyPrice, "TRY", datam);

    // Argentina math
    const ars = +review.ArgentinaPrice;
    if (Number.isFinite(ars) && ars > 0 && datam.ARS) {
      const phpPerARS = Number(datam.PHP) / Number(datam.ARS);
      const basePhp = ars * phpPerARS;
      const regionalityTax =
        ars * phpPerARS * 1.21 * ((1500 - 12100 * phpPerARS) / (12100 * phpPerARS));
      const argentinaVat = basePhp * 0.21;
      prices.Argentina = basePhp + argentinaVat + regionalityTax;
    }
    
    const vals = Object.values(prices).filter((v) => Number.isFinite(v) && v > 0);
    return vals.length ? Math.min(...vals) : Infinity;
  }


function cheapestRegionCode(review) {
  if (!datam || !datam.PHP) return null;

  // PlayStation: use new csvjsontr regional fields
  if (review.platform === "Playstation") {
    const prices = getPsRegionalPrices(review);

    let bestRegion = "";
    let bestPrice = Infinity;

    Object.entries(prices).forEach(([region, phpPrice]) => {
      if (Number.isFinite(phpPrice) && phpPrice > 0 && phpPrice < bestPrice) {
        bestRegion = region;
        bestPrice = phpPrice;
      }
    });

    return bestRegion;
  }

  // Nintendo: keep old logic
  const regionToPhp = {};
  const toPHP = (amt, ccy) =>
    +amt * (Number(datam.PHP) / Number(datam[ccy] || 1));

  const putMin = (code, value) => {
    if (!Number.isFinite(value) || value <= 0) return;
    if (regionToPhp[code] === undefined || value < regionToPhp[code]) {
      regionToPhp[code] = value;
    }
  };

  putMin("US", toPHP(review.SalePrice, "USD"));
  putMin("US", toPHP(review.Price, "USD"));
  putMin("CA", toPHP(review.CanadaPrice, "CAD"));
  putMin("PE", toPHP(review.PeruPrice, "PEN"));
  putMin("AU", toPHP(review.AustraliaPrice, "AUD"));
  putMin("CO", toPHP(review.ColombiaPrice, "COP"));
  putMin("ZA", toPHP(review.SouthafricaPrice, "ZAR"));
  putMin("BR", toPHP(review.BrazilPrice, "BRL"));
  putMin("NO", toPHP(review.NorwayPrice, "NOK"));
  putMin("PL", toPHP(review.PolandPrice, "PLN"));
  putMin("NZ", toPHP(review.NewZealandPrice, "NZD"));
  putMin("MX", toPHP(review.MexicoPrice, "MXN"));
  putMin("HK", toPHP(review.HongKongPrice, "HKD"));
  putMin("KR", toPHP(review.KoreaPrice, "KRW"));
  putMin("JP", toPHP(review.JapanPrice, "JPY"));
  putMin("SG", toPHP(review.SingaporePrice, "SGD"));
  putMin("MY", toPHP(review.MalaysiaPrice, "MYR"));
  putMin("TH", toPHP(review.ThailandPrice, "THB"));
  putMin("TR", toPHP(review.TurkeyPrice, "TRY"));

  const ars = +review.ArgentinaPrice;
  if (Number.isFinite(ars) && ars > 0 && datam.ARS) {
    const phpPerARS = Number(datam.PHP) / Number(datam.ARS);
    const basePhp = ars * phpPerARS;
    const vat = basePhp * 0.21;
    const regionality =
      basePhp * 1.21 * ((1500 - 12100 * phpPerARS) / (12100 * phpPerARS));

    putMin("AR", basePhp + vat + regionality);
  }

  let best = null;
  let bestVal = Infinity;

  for (const [code, val] of Object.entries(regionToPhp)) {
    if (val < bestVal) {
      bestVal = val;
      best = code;
    }
  }

  return best;
}

function normalizeGenre(genre = "") {
  return genre
    .toLowerCase()
    .replaceAll("role playing games", "role-playing, rpg")
    .replaceAll("driving/racing", "racing")
    .replaceAll("sport", "sports")
    .replaceAll("music/rhythm", "music")
    .replaceAll("simulator", "simulation")
    .replaceAll("brain training", "puzzle")
    .replaceAll("board game", "strategy")
    .replaceAll("party", "multiplayer")
    .replaceAll("family", "unique")
    .replaceAll("casual", "unique");
}

const currentPath = window.location.pathname;

const routePlatformField =
  currentPath === "/switch"
    ? "Switch"
    : currentPath === "/switch-2"
    ? "Switch 2"
    : currentPath === "/playstation"
    ? "Playstation"
    : platformField;

  // ---------- FILTERING + PAGINATION ----------
  let filteredReviews = useMemo(
    () =>
      latestField.filter((review) => {
        const cleanFilterField = filterField
          .replace(/[^a-zA-Z0-9é, -]/g, "")
          .replace("é", "e")
          .replace(/\s/g, "")
          .toLowerCase();

        const filterGenres = cleanFilterField
  ? cleanFilterField.split(",").map((g) => g.trim()).filter(Boolean)
  : [];

        const ratesReady = Boolean(datam && datam.PHP);

        let pricePass = true;
        if (priceRangeDropDown !== "All Price Range" && ratesReady) {
          const lowPhp = lowestPhpFor(review);
          pricePass =
            lowPhp <= priceRangeField &&
            (priceRangeLowExclusive ? lowPhp > priceRangeLow : lowPhp >= priceRangeLow);
        }

        let regionPass = true;
        if ((regionFilter.include.length || regionFilter.exclude.length) && ratesReady) {
          const minRegion = cheapestRegionCode(review);
          if (regionFilter.include.length && !regionFilter.include.includes(minRegion)) {
            regionPass = false;
          }
          if (regionFilter.exclude.length && regionFilter.exclude.includes(minRegion)) {
            regionPass = false;
          }
        }

        let deepSalePass = true;
        if (latestDropDown === "Best Deals" && ratesReady) {
          deepSalePass = isDeepSale(review);
        }

        const lowPass =
          !lowFilter ||
          saleStatus?.[review.Slug]?.[cheapestRegionCode(review)] === lowFilter;

        return (
          `${review.Title || ""} ${review.Slug || review.slug || ""}`
            .replace(/[^a-zA-Z0-9é ]/g, "")
            .replace("é", "e")
            .replace(/\s/g, "")
            .toLowerCase()
            .includes(
              searchQuery
                .replace(/[^a-zA-Z0-9é ]/g, "")
                .replace("é", "e")
                .replace(/\s/g, "")
                .toLowerCase()
            ) &&
(filterGenres.length === 0 ||
  filterGenres.some((filterGenre) =>
    normalizeGenre(review.genre || "").includes(filterGenre)
  )) &&
          review.platform
  .toLowerCase()
  .includes(routePlatformField.toLowerCase()) &&
        pricePass &&
        regionPass &&
        deepSalePass &&
        lowPass
        );
      }),
    [
      latestField,
      filterField,
      searchQuery,
      platformField,
      routePlatformField,
      priceRangeField,
      priceRangeLow,
      priceRangeLowExclusive,
      priceRangeDropDown,
      datam,
      regionFilter,
      lowFilter,
      saleStatus,
    ]
  );

  let { pageData, page, maxPage, jumpPage } = usePagination(filteredReviews, 40);

const prevPageRef = React.useRef(page);
const skipNextPageScrollRef = React.useRef(true);
const isRestoringHistoryRef = React.useRef(false);

useEffect(() => {
  if (!hydrated) return;

  if (skipNextPageScrollRef.current) {
    skipNextPageScrollRef.current = false;
    prevPageRef.current = page;
    return;
  }

  if (isRestoringHistoryRef.current) {
    prevPageRef.current = page;
    return;
  }

  if (prevPageRef.current !== page) {
    window.scrollTo({ left: 0, top: 0, behavior: "instant" });
    prevPageRef.current = page;
  }
}, [page, hydrated]);

  // --- URL / pagination refs (must be declared before effects that use them) ---
  const initialPageRef = React.useRef(1);
  const initialUrlAppliedRef = React.useRef(false);
  const hadPageParamRef = React.useRef(false);
  const initialPageConsumedRef = React.useRef(false);

  // --------- Reset page ONLY when filters actually change (not on first hydration) ---------
  useEffect(() => {
    if (!hydrated) return;

    // Build a stable signature of filters/sort (NOT page)
    const sig = [
      searchQuery || "",
      filterField || "",
      latestDropDown || "Popular",
      platformField || "",
      regionFilter.include.join(",") || "",
      regionFilter.exclude.join(",") || "",
      priceRangeDropDown || "All Price Range",
      lowFilter,
    ].join("|");

    // First run after hydration: record baseline, don't reset
    if (prevFilterSigRef.current === null) {
      prevFilterSigRef.current = sig;
      return;
    }

    // Only when filters actually change → reset to page 1
    if (prevFilterSigRef.current !== sig) {
      prevFilterSigRef.current = sig;
      jumpPage(1);
    }
  }, [
    hydrated,
    searchQuery,
    filterField,
    latestDropDown,
    platformField,
    regionFilter,
    priceRangeDropDown,
    priceRangeLow,
    priceRangeField,
    lowFilter,
    jumpPage,
  ]);

 // --------- Apply initial page from URL after list stabilizes (CLAMP) — run ONCE ---------
 useEffect(() => {
   if (!hydrated) return;
   if (initialPageConsumedRef.current) return; // already applied once
   if (lowFilter && !saleStatus) return; // list is empty until status data loads
 
   const initial = initialPageRef.current || 1;
if (initial <= 1) {
  if (page !== 1) {
    jumpPage(1);
  }

  initialPageConsumedRef.current = true;
  return;
}
 
   const pageSize = 40; // must match usePagination(..., 40)
   const max = Math.max(1, Math.ceil(filteredReviews.length / pageSize));
   const target = Math.min(initial, max);
 
   if (page !== target) {
     jumpPage(target);
   }
 
   // Mark as consumed so user interactions aren't overridden later
   initialPageConsumedRef.current = true;
   initialPageRef.current = 1; // clear out the initial page
 }, [hydrated, filteredReviews, page, jumpPage, lowFilter, saleStatus]);

  // 1) Load state from URL once on mount
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    hadPageParamRef.current = params.has("page");

    const s = readQP(params, "s", "");
    const genre = readQP(params, "genre", "All Genres");
    const sort = readQP(params, "sort", "Popular");
    const price = readQP(params, "price", "All Price Range");
    const regionIn = parseRegionList(params.get("regionIn"));
    const regionEx = parseRegionList(params.get("regionEx"));
    const regionLegacy = (params.get("region") || "").trim().toUpperCase();
    const region = {
      include: regionIn.length ? regionIn : regionLegacy ? [regionLegacy] : [],
      exclude: regionEx,
    };
    const p = parseInt(params.get("page") || "1", 10);

    initialPageRef.current = Number.isFinite(p) ? p : 1;

    setSearchQuery(s);
    setGenreDropDown(genre);
    setFilterField(genre === "All Genres" ? "" : genre);

    onLatestChange(sort);

    setPriceRangeDropDown(price);
    onPriceRangeChange(price);

    setRegionFilter(region);
    setLowFilter(readLow(params));

    // Defer: let pagination + child defaults settle before flipping hydrated
    if (Number.isFinite(p) && p > 1) {
      jumpPage(p);
    }
    // Ensure page state updates first
    requestAnimationFrame(() => {
      initialUrlAppliedRef.current = true; // we’ve pushed initial state
      setHydrated(true);
    });
  }, []);

  // 2) Reflect state → URL, but only on list routes and only after hydration
  useEffect(() => {
    if (!hydrated) return;
    // On the very first cycle after mount, wait until the initial URL state
    // has actually been applied to pagination to avoid stripping ?page=...
    if (!initialUrlAppliedRef.current) return;

    const pathname = window.location.pathname;
    const listPaths = ["/allgames", "/switch", "/switch-2", "/playstation"];

    if (listPaths.includes(pathname)) {
      const params = new URLSearchParams();
      if (searchQuery) params.set("s", searchQuery);
      if (genreDropDown) params.set("genre", genreDropDown);
      if (latestDropDown) params.set("sort", latestDropDown);
      if (priceRangeDropDown) params.set("price", priceRangeDropDown);
      if (lowFilter) params.set("low", lowFilter);
      if (regionFilter.include.length) params.set("regionIn", regionFilter.include.join(","));
      if (regionFilter.exclude.length) params.set("regionEx", regionFilter.exclude.join(","));
      if (regionFilter.include.length === 1 && regionFilter.exclude.length === 0) {
        params.set("region", regionFilter.include[0]);
      }
      //if (page > 1) params.set("page", page);

      // Write a safe, 1-based page number to the URL (avoid transient 0 from pagination init)
      const safePage = Math.max(1, Number.isFinite(page) ? Number(page) : 1);
      if (safePage > 1 || hadPageParamRef.current) {
        params.set("page", String(safePage));
      }

      const qs = params.toString();
      const newUrl = `${pathname}${qs ? `?${qs}` : ""}`;
      // After initial hydration, write changes as NEW history entries
      const oldUrl = window.location.pathname + window.location.search;
const oldParams = new URLSearchParams(window.location.search);
const oldPage = oldParams.get("page") || "1";
const newPage = params.get("page") || "1";

if (oldPage !== newPage) {
  window.history.pushState({}, "", newUrl);
} else if (oldUrl !== newUrl) {
  window.history.replaceState({}, "", newUrl);
}
    }
  }, [
    hydrated,
    searchQuery,
    genreDropDown,
    latestDropDown,
    priceRangeDropDown,
    regionFilter,
    lowFilter,
    page,
  ]);

  // 3) Respond to browser Back/Forward by re-reading the URL (popstate)
   useEffect(() => {
const onPop = () => {
  isRestoringHistoryRef.current = true;

  setTimeout(() => {
    isRestoringHistoryRef.current = false;
  }, 1500);

  const params = new URLSearchParams(window.location.search);
       const s = readQP(params, "s", "");
       const genre = readQP(params, "genre", "All Genres");
       const sort = readQP(params, "sort", "Popular");
       const price = readQP(params, "price", "All Price Range");
       const regionIn = parseRegionList(params.get("regionIn"));
       const regionEx = parseRegionList(params.get("regionEx"));
       const regionLegacy = (params.get("region") || "").trim().toUpperCase();
       const region = {
         include: regionIn.length ? regionIn : regionLegacy ? [regionLegacy] : [],
         exclude: regionEx,
       };
       const p = parseInt(params.get("page") || "1", 10);
 
       setSearchQuery(s);
       setGenreDropDown(genre);
       setFilterField(genre === "All Genres" ? "" : genre);
       setPriceRangeDropDown(price);
       onPriceRangeChange(price);
      setRegionFilter(region);
       setLowFilter(readLow(params));
       onLatestChange(sort);
       jumpPage(Number.isFinite(p) ? p : 1);
     };
     window.addEventListener("popstate", onPop);
     return () => window.removeEventListener("popstate", onPop);
   }, [jumpPage]);


  // ---------- BACKGROUND ----------
  const mostPopularGame = sortJson(
    [...reviewssw].filter((game) => game.Image && Number.isFinite(Number(game.Popularity))),
    "Popularity",
    "int",
    false
  )[0];

  const BackgroundContainer = styled.div`
  --blur-radius: 20px;
  position: absolute;
  width: 100%;
  height: 60vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;

  background: var(--hero-bg);

  z-index: -1;

  &:after {
    --color-background--rgb: var(--hero-gradient-rgb);

    content: "";
    position: absolute;
    height: 50%;
    left: 0;
    right: 0;
    bottom: 0;

    background: linear-gradient(
      0deg,
      rgba(var(--color-background--rgb), 1) 0,
      rgba(var(--color-background--rgb), 0.987) 8.1%,
      rgba(var(--color-background--rgb), 0.951) 15.5%,
      rgba(var(--color-background--rgb), 0.896) 22.5%,
      rgba(var(--color-background--rgb), 0.825) 29%,
      rgba(var(--color-background--rgb), 0.741) 35.3%,
      rgba(var(--color-background--rgb), 0.648) 41.2%,
      rgba(var(--color-background--rgb), 0.55) 47.1%,
      rgba(var(--color-background--rgb), 0.45) 52.9%,
      rgba(var(--color-background--rgb), 0.352) 58.8%,
      rgba(var(--color-background--rgb), 0.259) 64.7%,
      rgba(var(--color-background--rgb), 0.175) 71%,
      rgba(var(--color-background--rgb), 0.104) 77.5%,
      rgba(var(--color-background--rgb), 0.049) 84.5%,
      rgba(var(--color-background--rgb), 0.013) 91.9%,
      rgba(var(--color-background--rgb), 0)
    );
  }
`;

  const Background = styled.div`
    --blur-radius: 20px;
    background-image: url(${mostPopularGame?.Image || reviewssw[0]?.Image || ""});
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: calc(var(--blur-radius) * -1) calc(var(--blur-radius) * -1);
    background-size: cover;
    background-position: 50%;
    mix-blend-mode: var(--hero-blend);
    filter: blur(var(--blur-radius));
  `;

  // ---- props for child components (Search + CardGroup) ----
  const SearchCmpProps = {
    onPlatformChange,
    onPlatformDrop,
    clearPriceRange,
    onPriceRangeDrop,
    searchQuery,
    setSearchQuery,
    clearGenre,
    onDropDownChange,
    onRegionChange,
  };

  const CardGroupProps = {
    clearPriceRange,
    priceRangeDropDown,
    priceRangeLow,
    priceRangeField,
    onPriceRangeDrop,
    onPriceRangeChange,
    onPriceRangeBoundsChange,
    clearGenre,
    onPlatformDrop,
    onPlatformChange,
    platformDropDown,
    onLatestDrop,
    onLatestChange,
    latestDropDown,
    clearFilter,
    genreDropDown,
    onDropDownChange,
    onFilterChange,
    clearSearchChange,
    onRegionChange,
    regionFilter,
    searchQuery,
    page,
    setSearchQuery,
    jumpPage,
    filteredReviews,
    pageData,
    maxPage,
    datam,
    lowFilter,
    setLowFilter,
    // for ListPage init defaults
    setPlatformField,
    setPlatformDropDown,
    setRegionFilter,
  };

  // ---- route table (defaults + Helmet text per route) ----
  const ROUTES = [
    {
      path: "/allgames",
      defaults: { platform: "", platformLabel: "All Platforms", region: "" },
      helmet: {
        title: "All Games Deals | May Sale Ba?",
        description: "Browse the latest Nintendo Switch and PlayStation deals in the Philippines with price comparisons in PHP.",
        canonical: "https://maysaleba.com/allgames",
      },
    },
    {
      path: "/switch",
      defaults: { platform: "Switch", platformLabel: "Switch", region: "" },
      helmet: {
        title: "Nintendo Switch | May Sale Ba?",
        description: `Find ${reviewssw.length}+ Nintendo Switch game deals and discounts in the Philippines, updated in PHP.`,
        canonical: "https://maysaleba.com/switch",
      },
    },
    {
      path: "/switch-2",
      defaults: { platform: "Switch 2", platformLabel: "Switch 2", region: "" },
      helmet: {
        title: "Nintendo Switch 2 | May Sale Ba?",
        description: `Compare the latest Nintendo Switch 2 deals and discounts in the Philippines with updated PHP prices.`,
        canonical: "https://maysaleba.com/switch-2",
      },
    },
    {
      path: "/playstation",
      defaults: { platform: "Playstation", platformLabel: "Playstation", region: "" },
      helmet: {
        title: "PlayStation | May Sale Ba?",
        description: `Discover ${reviewsstf.length}+ PlayStation deals and discounts in the Philippines, updated in PHP.`,
        canonical: "https://maysaleba.com/playstation",
      },
    },
  ];

  return (
    <Router>
      <ScrollToTop />
<NaviBar
  onPlatformDrop={onPlatformDrop}
  clearFilter={clearFilter}
  clearSearchChange={clearSearchChange}
  searchQuery={searchQuery}
  setSearchQuery={setSearchQuery}
  darkMode={darkMode}
  setDarkMode={setDarkMode}
/>

      <BackgroundContainer>
        <Background />
      </BackgroundContainer>

      {/* Home */}
      <Route
        path="/"
        exact
        render={() => (
          <div>
            <Search {...SearchCmpProps} />
            <Suspense fallback={<RouteLoadingFallback />}>
              <MainPage
                filteredReviews={filteredReviews}
                pageData={pageData}
                reviewsps={latestField.filter((review) => review.platform === "Playstation")}
                datam={datam}
              />
            </Suspense>
            <Helmet>
              <meta charSet="utf-8" />
              <title>{`May Sale Ba? - Nintendo Switch and PlayStation deals in the Philippines`}</title>
              <meta
                name="description"
                content="Track the latest Nintendo Switch and PlayStation deals in the Philippines with price comparisons in PHP."
              />
              <link rel="canonical" href="https://maysaleba.com/" />
              <meta name="robots" content="index,follow" />
            </Helmet>
          </div>
        )}
      />

      {/* List routes */}
      {ROUTES.map((r) => (
        <Route
          key={r.path}
          path={r.path}
          exact
          render={() => (
            <ListPage
              defaults={r.defaults}
              SearchCmpProps={SearchCmpProps}
              CardGroupProps={CardGroupProps}
              HelmetProps={r.helmet}
            />
          )}
        />
      ))}

      {/* Detail page */}
      <Route
        path="/games/:games"
        exact
        render={({ match }) => (
          <div>
            <Suspense fallback={<RouteLoadingFallback />}>
              <Content makeswitch={makeswitch} datam={datam} match={match} />
            </Suspense>
          </div>
        )}
      />

      {/* Gift Cards */}
      <Route
        path="/giftcards"
        render={() => (
          <div>
            <Suspense fallback={<RouteLoadingFallback />}>
              <GiftCards searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
            </Suspense>
            <Helmet>
              <meta charSet="utf-8" />
              <title>Gift Cards and Digital Store Help | May Sale Ba?</title>
              <meta
                name="description"
                content="Learn about gift card options and digital purchase guidance for Nintendo Switch and PlayStation deals in the Philippines."
              />
              <link rel="canonical" href="https://maysaleba.com/giftcards" />
              <meta name="robots" content="index,follow" />
            </Helmet>
          </div>
        )}
      />

      {/* FAQ */}
      <Route
        path="/faq"
        render={() => (
          <div>
            <Suspense fallback={<RouteLoadingFallback />}>
              <FAQ searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
            </Suspense>
            <Helmet>
              <meta charSet="utf-8" />
              <title>FAQ - Nintendo and PlayStation Deal Questions | May Sale Ba?</title>
              <meta
                name="description"
                content="Find answers about Nintendo Switch, PlayStation deals, buying tips, and regional pricing in the Philippines."
              />
              <link rel="canonical" href="https://maysaleba.com/faq" />
              <meta name="robots" content="index,follow" />
            </Helmet>
          </div>
        )}
      />

      {/* Pasabuy */}
      <Route
        path="/pasabuy"
        render={() => (
          <div>
            <Suspense fallback={<RouteLoadingFallback />}>
              <Pasabuy searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
            </Suspense>
            <Helmet>
              <meta charSet="utf-8" />
              <title>Pasabuy Guide for Nintendo and PlayStation Purchases | May Sale Ba?</title>
              <meta
                name="description"
                content="Learn how Pasabuy works for Nintendo Switch and PlayStation purchases in the Philippines and other regions."
              />
              <link rel="canonical" href="https://maysaleba.com/pasabuy" />
              <meta name="robots" content="index,follow" />
            </Helmet>
          </div>
        )}
      />
<Route
  path="/flip"
  exact
  render={() => (
    <div>
      <Suspense fallback={<RouteLoadingFallback />}>
        <Flip />
      </Suspense>
      <Helmet>
        <title>Coin Flip Game | May Sale Ba?</title>
        <meta
          name="description"
          content="Try a simple coin flip game while browsing Nintendo and PlayStation deals in the Philippines."
        />
        <link rel="canonical" href="https://maysaleba.com/flip" />
        <meta name="robots" content="index,follow" />
      </Helmet>
    </div>
  )}
/>

    </Router>


  );
}
